import FormControl from "@mui/material/FormControl";
import Typography, { TypographyProps } from "@mui/material/Typography";
import styled from "styled-components";

export const CurrencyFormControl = styled(FormControl)`
  width: 120px;
`;

export const ProjectsContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const Description = styled(Typography)`
  /* margin: ${({ theme }) => theme.spacing(2, 0, 0, 1)}; */
  margin: ${({ theme }) => theme.spacing(1, 0, 0, 0)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  font-size: smaller;
`;

export const Description2 = styled(Typography)`
  /* margin: ${({ theme }) => theme.spacing(0.5, 0, 3, 1)}; */
  margin: ${({ theme }) => theme.spacing(0.5, 0, 3, 0)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  font-size: smaller;
`;

export const Title = styled(Typography)<
  TypographyProps<"h2", { component: "h2" }>
>`
  margin-right: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const DetailsTitle = styled.span`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.primary.main
      : theme.palette.text.secondary};
  font-weight: 500;
  font-size: smaller;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const DetailsInfo = styled.span`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.text.primary
      : theme.palette.primary.main};
  font-weight: 450;
  margin-right: ${({ theme }) => theme.spacing(2)};
  font-size: smaller;
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
`;
